import { useEffect, useState } from "react";
import { Monogram } from "../components/Monogram";

/**
 * Desktop holding page — shown on viewports >= 1024px.
 * The marketing site lives on WordPress; this app is mobile-only.
 */
export default function DesktopHolding() {
  const [qrSrc, setQrSrc] = useState("");
  useEffect(() => {
    const url = (typeof window !== "undefined" ? window.location.origin : "https://habano.app") + "/";
    const api = `https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=0&color=C8A063&bgcolor=0B0A09&data=${encodeURIComponent(url)}`;
    setQrSrc(api);
  }, []);

  return (
    <main
      data-testid="desktop-holding"
      className="min-h-screen flex items-center justify-center px-8 py-16"
      style={{
        background:
          "radial-gradient(ellipse 60% 50% at 50% 30%, rgba(200,160,99,0.08) 0%, transparent 60%), linear-gradient(180deg, #0B0A09 0%, #080808 100%)",
      }}
    >
      <div className="max-w-2xl w-full text-center">
        <div className="flex justify-center mb-10">
          <Monogram size={64} />
        </div>
        <div className="eyebrow text-gold mb-5">Habano · Est. La Habana 2025</div>
        <h1 className="font-display text-5xl sm:text-6xl text-foreground leading-[1.05] tracking-tight">
          For the best experience{" "}
          <span className="font-display-italic text-gold">open Habano.app on your phone.</span>
        </h1>
        <p className="text-foreground/65 mt-8 text-base leading-relaxed max-w-md mx-auto">
          Scan the code below with your phone camera, or visit{" "}
          <span className="text-gold">habano.app</span> on mobile.
        </p>
        <div className="mt-12 inline-flex flex-col items-center">
          <div
            className="p-4 rounded-3xl"
            style={{
              background: "#0B0A09",
              border: "1px solid rgba(200, 160, 99, 0.3)",
              boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
            }}
          >
            {qrSrc && <img src={qrSrc} alt="Scan to open on mobile" width={280} height={280} className="block" />}
          </div>
          <span className="mt-5 text-[11px] uppercase tracking-[0.28em] text-foreground/55">Scan with your camera</span>
        </div>
      </div>
    </main>
  );
}
